import { ArrowLeftIcon, ArrowRightIcon } from "@chakra-ui/icons";
import { Box, useBreakpointValue } from "@chakra-ui/react";
import { useState } from "react";
import Slider from 'react-slick';
import SliderIconButton from "./slider-icon-button";

interface SliderProps {
    height?: number | string,
    options: any,
    children: any,
    arrows?:boolean
};

const LogosSlider: React.FC<SliderProps> = ({ height, options, children, arrows }) => {
    const [slider, setSlider] = useState<Slider | null>(null);
    const topSlider = useBreakpointValue({ base: '90%', md: '50%' });
    const sideSlider = useBreakpointValue({ base: '30%', md: '10px' });

    return (
        <Box
            position={'relative'}
            height={height}
            mt={5}
            width={'full'}
            overflow={'hidden'}>
            <link
                rel="stylesheet"
                type="text/css"
                charSet="UTF-8"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
            />
            <link
                rel="stylesheet"
                type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
            />
            {
                arrows &&
                <SliderIconButton ariaLabel={'left-arrow'} isLeft={true} side={sideSlider} top={topSlider} clickHandler={() => slider?.slickPrev()}>
                    <ArrowLeftIcon />
                </SliderIconButton>
            }

            {
                arrows &&
                <SliderIconButton ariaLabel={'right-arrow'} isLeft={false} side={sideSlider} top={topSlider} clickHandler={() => slider?.slickNext()}>
                    <ArrowRightIcon />
                </SliderIconButton>
            }
            
            <Slider {...options} ref={(slider) => setSlider(slider)}>
                {children}
            </Slider>
        </Box>
    );
};

export default LogosSlider;